import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Hero.css";

function Hero() {
  const navigate = useNavigate();

  const images = [
    "/images/banner.jpeg",
    "/images/poster2.jpeg",
    "/images/poster3.jpeg",
    "/images/poster4.jpeg",
    "/images/poster5.jpeg",
    "/images/revision.jpg", 
    "/images/Hostel.jpg",
    "/images/building.jpeg",
    "/images/road.jpeg",
    "/images/class.jpeg",
  
  ];

  const [currentSlide, setCurrentSlide] = useState(1);
  const [isPaused, setIsPaused] = useState(false);
  const sliderRef = useRef(null);
  const touchStartX = useRef(0);

  // Duplicate slides for infinite effect
  const slides = [images[images.length - 1], ...images, images[0]];

  /* AUTO SLIDE */
  useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => prev + 1);
    }, 3500);

    return () => clearInterval(interval);
  }, [isPaused]);

  /* HANDLE LOOP */
  useEffect(() => {
    const slider = sliderRef.current;

    const handleTransitionEnd = () => {
      if (currentSlide === slides.length - 1) {
        slider.style.transition = "none";
        setCurrentSlide(1);
        slider.style.transform = `translateX(-100%)`;
      }

      if (currentSlide === 0) {
        slider.style.transition = "none";
        setCurrentSlide(slides.length - 2);
        slider.style.transform = `translateX(-${(slides.length - 2) * 100}%)`;
      }
    };

    slider.addEventListener("transitionend", handleTransitionEnd);
    return () =>
      slider.removeEventListener("transitionend", handleTransitionEnd);
  }, [currentSlide, slides.length]);

  /* APPLY TRANSFORM */
  useEffect(() => {
    const slider = sliderRef.current;
    slider.style.transition = "transform 0.6s ease-in-out";
    slider.style.transform = `translateX(-${currentSlide * 100}%)`;
  }, [currentSlide]);

  /* SWIPE SUPPORT */
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (diff > 50) setCurrentSlide((prev) => prev + 1);
    if (diff < -50) setCurrentSlide((prev) => prev - 1);
  };

  return (
    <section className="hero">
      {/* ===== TOP SECTION ===== */}
      <div className="hero-top">
        {/* LEFT CONTENT */}
        <div className="hero-content">
          <h1>
            Result Speaks <br />
            <span>
              <img
                src="/images/access.png"
                alt="ACCESS"
                className="access-img"
              />{" "}
              Delivers
            </span>
          </h1>

          <p className="hero-tagline">
            Trusted by <strong>Thousands of students</strong>
          </p>
        </div>

        {/* IMAGE SLIDER */}
        <div
          className="hero-image"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          <div className="image-slider" ref={sliderRef}>
            {slides.map((img, i) => (
              <img src={img} key={i} alt="slide" />
            ))}
          </div>

          {/* DOTS */}
          <div className="slider-dots">
            {images.map((_, index) => (
              <span
                key={index}
                className={`dot ${
                  index ===
                  (currentSlide - 1 + images.length) % images.length
                    ? "active"
                    : ""
                }`}
                onClick={() => setCurrentSlide(index + 1)}
              />
            ))}
          </div>
        </div>
      </div>

      {/* ===== COURSES ===== */}
      <h2 className="hero-subtitle">Explore Courses</h2>

      <div className="course-grid">
        <div
          className="course-card"
          onClick={() => navigate("/classroom")}
        >
          <div className="course-icon">📚</div>
          <h3>Tuitions</h3>
          <p>Classroom learning from Class 1 to 10</p>
        </div>

        <div
          className="course-card"
          onClick={() => navigate("/hostel")}
        >
          <div className="course-icon">🏫</div>
          <h3>Stay & Study</h3>
          <p>Residential program for Class 9 & 10</p>
        </div>

        <div
          className="course-card"
          onClick={() => navigate("/material")}
        >
          <div className="course-icon">📖</div>
          <h3>Study Material</h3>
          <p>Notes, DPPs & exam resources</p>
        </div>

        <div
          className="course-card"
          onClick={() => navigate("/test-series")}
        >
          <div className="course-icon">📝</div>
          <h3>Test Series</h3>
          <p>Exam-level practice & analysis</p>
        </div>
      </div>

      {/* ===== ADMISSIONS ===== */}
      <h2 className="hero-subtitle">Admissions Open</h2>

      <div className="admission">
        <img
          src="/images/admissions.png"
          alt="Admissions Open"
          className="admission-image"
        />

        {/* CTA BUTTONS */}
        <div className="admission-cta">
          <a href="tel:+919964585585" className="cta-btn call">
            📞 Call Now
          </a>

          <a
            href="https://wa.me/919964585585?text=I%20want%20admission%20details"
            target="_blank"
            rel="noopener noreferrer"
            className="cta-btn whatsapp"
          >
            💬 WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}

export default Hero;
